export enum GetManifestTypes {
  SEARCH_MANIFEST_CONFIG = '[MANIFEST] Search MANIFEST',
  SEARCH_MANIFEST_CONFIG_SUCCESS = '[MANIFEST] Search MANIFEST Success',
  SEARCH_MANIFEST_CONFIG_ERROR = '[MANIFEST] Search MANIFEST Error',
  VALIDATE_GOOGLE_API_KEY = '[MANIFEST] Validate Google Api Key',
  VALIDATE_GOOGLE_API_KEY_SUCCESS = '[MANIFEST] Validate Google Api Key Success',
  VALIDATE_GOOGLE_API_KEY_ERROR = '[MANIFEST] Validate Google Api Key Error',
}

type GetManifestConfiguration = {
  type: typeof GetManifestTypes.SEARCH_MANIFEST_CONFIG;
};
type GetManifestConfigurationSuccess = {
  type: typeof GetManifestTypes.SEARCH_MANIFEST_CONFIG_SUCCESS;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: { data: any };
};
type GetManifestConfigurationError = {
  type: typeof GetManifestTypes.SEARCH_MANIFEST_CONFIG_ERROR;
  payload: { error: string };
};
type ValidateGoogleAPIKEY = {
  type: typeof GetManifestTypes.VALIDATE_GOOGLE_API_KEY;
};
type ValidateGoogleAPIKEYSuccess = {
  type: typeof GetManifestTypes.VALIDATE_GOOGLE_API_KEY_SUCCESS;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: { data: any };
};
type ValidateGoogleAPIKEYError = {
  type: typeof GetManifestTypes.VALIDATE_GOOGLE_API_KEY_ERROR;
  payload: { error: string };
};

export type ManifestActionTypes =
  | GetManifestConfiguration
  | GetManifestConfigurationSuccess
  | GetManifestConfigurationError
  | ValidateGoogleAPIKEY
  | ValidateGoogleAPIKEYSuccess
  | ValidateGoogleAPIKEYError;

export const manifestActionsTypes = {
  getManifestInfo: (): GetManifestConfiguration => ({
    type: GetManifestTypes.SEARCH_MANIFEST_CONFIG,
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getManifestInfoSuccess: (data: any): GetManifestConfigurationSuccess => ({
    type: GetManifestTypes.SEARCH_MANIFEST_CONFIG_SUCCESS,
    payload: { data },
  }),
  getManifestInfoError: (error: string): GetManifestConfigurationError => ({
    type: GetManifestTypes.SEARCH_MANIFEST_CONFIG_ERROR,
    payload: { error },
  }),
  validateGoogleAPI: (): ValidateGoogleAPIKEY => ({
    type: GetManifestTypes.VALIDATE_GOOGLE_API_KEY,
  }),
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  validateGoogleAPISuccess: (data: any): ValidateGoogleAPIKEYSuccess => ({
    type: GetManifestTypes.VALIDATE_GOOGLE_API_KEY_SUCCESS,
    payload: { data },
  }),
  validateGoogleAPIError: (error: string): ValidateGoogleAPIKEYError => ({
    type: GetManifestTypes.VALIDATE_GOOGLE_API_KEY_ERROR,
    payload: { error },
  }),
};
